import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  gamesCoupons: [],
  selectedCoupon: {},
};

const localSlice = createSlice({
  name: "coupons",
  initialState,
  reducers: {
    setGamesToCoupon: (state, action) => {
      state.gamesCoupons = action.payload;
    },
    setSelectedCoupon: (state, action) => {
      state.selectedCoupon = action.payload;
    },
  },
});

export const { setGamesToCoupon, setSelectedCoupon } = localSlice.actions;

export default localSlice.reducer;
